export default __webpack_public_path__ + "static/youtubeHint-c8a8a49b6124b3175f923e3f69c8b02d.jpg";